﻿import LfDataService from '../../../Services/LfDataService';

import {
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';


export const fetchWizardQuestions = (data) => {
    return {
        type: 'FETCH_WIZARD',
        data: data
    };
}

export const wizardFormSubmittedAction = (data) => {
    return {
        type: 'WIZARD_FORM_SUBMITTED',
        data: data
    };
}

export const wizardFormSubmitFailedAction = (hasFailed) => {
    return {
        type: 'WIZARD_FORM_SUBMIT_FAILED',
        data: !!hasFailed
    };
}


export const fetchWizardQuestionsData = () => {

    const lfDataService = new LfDataService();

    return (dispatch) => {
        let questions;
        lfDataService.getWizardQuestions()
        .then(data => {

            questions = data;
            dispatch(fetchWizardQuestions(questions.questionGroups));

        })
        .catch(e => {
            dispatch(pageErrorAction(e));
            dispatch(pageHasErroredAction(true));
        });
    };
}


export const submitWizardFormDataAction = (data) => {

    const lfDataService = new LfDataService();

    return (dispatch) => {

        lfDataService.submitWizardForm(data)

            .then(result => {

                if (result.success) {
                    dispatch(wizardFormSubmitFailedAction(false))
                    dispatch(wizardFormSubmittedAction(data));

                    return;

                } else {
                    dispatch(wizardFormSubmitFailedAction(true));
                    dispatch(pageErrorAction('kunde inte uppdatera dina uppgifter'));
                    dispatch(pageHasErroredAction(true));
                }
            })
            .catch(e => {
                dispatch(wizardFormSubmitFailedAction(true));
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    }
}